import React, { FC, useEffect, useState } from 'react';
import { SCUIButton, SCUINoRecordComponent, SCUILoadingLinear } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import {
    Grid,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    SelectChangeEvent,
    Checkbox,
    ListItemText,
} from '@mui/material';
import { initialState } from './CargoManagement.helper';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { CargoManagementQuery } from '../../services/query/';
import { SCUICargoOrderLimitEdit } from './components/SCUICargoOrderLimitEdit/SCUICargoOrderLimitEdit';
export const CargoManagement: FC<any> = () => {
    const cityId = 1;
    const [filterInput, setFilterInput] = useState(initialState.filterInfo);
    const [companyList, setCompanyList] = useState([]);
    const [priorityCities, setPriorityCities] = React.useState<any>();
    const [cityList, setCityList] = React.useState([]);
    const [selectedCityIdList, setSelectedCityIdList] = React.useState<any>([]);
    const [selectedCityName, setSelectedCityName] = React.useState<string[]>([]);
    const [countyList, setCountyList] = React.useState([]);
    const [companyId, setCompanyId] = React.useState(0);
    const [countyId, setCountyId] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [drawerEditOpen, setDrawerEditOpen] = React.useState(false);
    const [selectedOrderItem, setSelectedOrderItem] = useState<any>();
    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        setSelectedOrderItem(selectedRows);
    }, [selectedRows]);
    useEffect(() => {
        GetCargoCompanyList();
        GetCityList();
    }, []);
    useEffect(() => {
        GetCountyList();
    }, [selectedCityIdList]);
    const GetCargoCompanyList = async () => {
        try {
            CargoManagementQuery.CargoCompanyList().then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            value: item.id,
                            text: item.name,
                        };
                    });
                    setCompanyList(parseData && [...[{ value: '0', text: t('general.all') }], ...parseData]);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetCityList = async () => {
        try {
            let params = {
                addressEntityTypeId: 3,
                countryId: 1,
            };
            CargoManagementQuery.CityList(params).then((res: any) => {
                if (res.data.addressEntities) {
                    let parseData = res.data.addressEntities.map((item: any) => {
                        return {
                            value: item.addressEntityId,
                            text: item.name,
                        };
                    });
                    setCityList(parseData);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetCountyList = async () => {
        try {
            let params = {
                ParentAddressEntityIdList: selectedCityIdList,
                countryId: 1,
            };
            if (selectedCityIdList.length > 0) {
                CargoManagementQuery.CountyList(params).then((res: any) => {
                    if (res.data.addressEntities) {
                        let parseData = res.data.addressEntities.map((item: any) => {
                            return {
                                value: item.addressEntityId,
                                text: item.name,
                            };
                        });
                        setCountyList(parseData && [...[{ value: '0', text: t('general.all') }], ...parseData]);
                    } else {
                        Swal.fire('Service Error', res.errorMessage, 'error');
                    }
                });
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'id', flex: 1, hide: true },
        {
            field: 'changedDate',
            headerName: t('cargoManagement.changedDate'),
            flex: 1,
        },
        { field: 'cityName', headerName: t('cargoManagement.cityName'), flex: 1 },
        {
            field: 'countyName',
            headerName: t('cargoManagement.countyName'),
            flex: 1,
        },
        {
            field: 'orderLimit',
            headerName: t('cargoManagement.orderLimit'),
            flex: 1,
        },
        {
            field: 'shippingCompanyName',
            headerName: t('cargoManagement.shippingCompanyName'),
            flex: 1,
        },
    ];
    const handleChangeFilterInput = () => {
        setFilterInput({ ...filterInput, companyId: companyId, cityId: cityId });
        listele();
    };
    const handleCityChange = (event: SelectChangeEvent<typeof selectedCityName>) => {
        const {
            target: { value },
        } = event;
        const selectedCityNames = typeof value === 'string' ? value.split(',') : value;
        setSelectedCityName(selectedCityNames);
        const selectedCityIds = cityList
            .filter((city: any) => selectedCityNames.includes(city.text))
            .map((city: any) => city.value);

        setSelectedCityIdList(selectedCityIds);
    };

    const onDrawerEditClose = () => setDrawerEditOpen(false);
    const handleSelectionModelChange = (model: any[]) => {
        const selectedData = model.map((id: number) => {
            return priorityCities.find((city: any) => city.id === id);
        });
        setSelectedRows(selectedData);
    };
    const listele = async () => {
        setLoading(true);
        const selectedCityIds = cityList
            .filter((city: any) => selectedCityName.includes(city.text))
            .map((city: any) => city.value);
        try {
            let params = {
                cityId: selectedCityIds,
                shippingCompanyId: companyId,
                countyId: countyId,
            };
            CargoManagementQuery.CargoPriorityList(params).then((res: any) => {
                if (res) {
                    let parseData = res.data.map((item: any, index: any) => {
                        return {
                            id: index,
                            changedDate: item.changedDate,
                            cityId: item.cityId,
                            cityName: item.cityName,
                            countyId: item.countyId,
                            countyName: item.countyName,
                            isActive: item.isActive,
                            orderLimit: item.orderLimit,
                            shippingCompanyId: item.shippingCompanyId,
                            shippingCompanyName: item.shippingCompanyName,
                        };
                    });
                    setPriorityCities(parseData);
                } else {
                    Swal.fire('Service Error', res.errorMessage, 'error');
                }
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
        setLoading(false);
    };
    const refreshFunc = () => {
        listele();
    };
    return (
        <SCUIContent>
            <SCUIGeneralDrawer
                open={drawerEditOpen}
                width={'400px'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerEditOpen(false);
                    }
                }}
            >
                <SCUICargoOrderLimitEdit
                    selectedRow={selectedOrderItem}
                    onClose={onDrawerEditClose}
                    refresh={refreshFunc}
                    setSelectedRow={setSelectedRows}
                />
            </SCUIGeneralDrawer>
            <Grid
                size={{
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <Grid container direction="row" spacing={2} sx={{ marginLeft: '0.5rem' }}>
                    <SCUIBreadCrumb
                        title={'Kargo Yönetimi'}
                        componentLink={'/cargoManagement'}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setPriorityCities([]);
                            setSelectedRows([]);
                        }}
                    />
                    <SCUILoadingLinear display={loading} />
                </Grid>

                <Grid
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    {priorityCities && priorityCities.length > 0 && (
                        <Grid
                            style={{ direction: 'rtl' }}
                            size={{
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUIButton
                                text={'Düzenle'}
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                onClick={() => {
                                    if (selectedRows.length > 0) {
                                        setDrawerEditOpen(true);
                                    } else {
                                        Swal.fire('Error', t('general.noSelectionMade'), 'error');
                                    }
                                }}
                            />
                        </Grid>
                    )}
                    <Grid
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {priorityCities && priorityCities.length > 0 ? (
                            <div>
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <SCUICustomDataGrid
                                        selectionOnClick={true}
                                        checkboxSelection
                                        rows={priorityCities}
                                        columns={columns}
                                        onSelectionModelChange={handleSelectionModelChange}
                                        selectionModel={selectedRows.map((row) => row.id)}
                                    />
                                </Grid>
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignContent: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <SCUINoRecordComponent />

                                <FormControl style={{ width: 450, margin: '20px' }}>
                                    <InputLabel id="labelApp">{t('cargoManagement.selectCargoCompany')}</InputLabel>
                                    <Select
                                        label={t('cargoManagement.selectCargoCompany')}
                                        labelId="labelApp"
                                        id="parentMenuLabel"
                                        value={companyId}
                                        onChange={(event) => {
                                            setCompanyId(Number(event.target.value));
                                            if (companyId == 0) {
                                                setCountyId(0);
                                            }
                                        }}
                                        fullWidth
                                    >
                                        {companyList &&
                                            companyList.map((comp: any) => (
                                                <MenuItem key={comp.value} id={comp.value} value={comp.value}>
                                                    {comp.text}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                <FormControl sx={{ margin: '20px', width: 450 }}>
                                    <InputLabel id="labelApp">{t('cargoManagement.selectCity')}</InputLabel>
                                    <Select
                                        label={t('cargoManagement.selectCity')}
                                        labelId="labelApp"
                                        id="parentMenuLabel"
                                        multiple
                                        value={selectedCityName}
                                        onChange={handleCityChange}
                                        renderValue={(selected) => selected.join(', ')}
                                        fullWidth
                                    >
                                        {cityList.map((name: any, index: any) => (
                                            <MenuItem key={index} value={name.text}>
                                                <Checkbox checked={selectedCityName.indexOf(name.text) > -1} />
                                                <ListItemText primary={name.text} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {companyId != 0 && (
                                    <FormControl style={{ width: 450, margin: '20px' }}>
                                        <InputLabel id="labelApp">{t('cargoManagement.selectCounty')}</InputLabel>
                                        <Select
                                            label={t('cargoManagement.selectCounty')}
                                            labelId="labelApp"
                                            id="parentMenuLabel"
                                            value={countyId}
                                            onChange={(event) => {
                                                setCountyId(Number(event.target.value));
                                            }}
                                            fullWidth
                                        >
                                            {countyList &&
                                                countyList.map((county: any) => (
                                                    <MenuItem key={county.value} id={county.value} value={county.value}>
                                                        {county.text}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                )}
                                <FormControl style={{ width: 450, margin: '10px' }}>
                                    <SCUIButton
                                        text={t('general.filter')}
                                        type="primary"
                                        sizeType="default"
                                        size={'l'}
                                        onClick={() => {
                                            handleChangeFilterInput();
                                        }}
                                    />
                                </FormControl>
                            </div>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
